import { SupplierAccount } from './types';
import { BillingContactPDFType } from '../../components/Pdfs/PdfComponents/PdfBillingContactDetails';

export const getPdfSupplierInfo = (currSupplier: SupplierAccount | undefined): BillingContactPDFType => {
    return {
        name: currSupplier?.supplierCompanyName || '',
        address: currSupplier?.address?.address || '',
        city: currSupplier?.address?.city || '',
        country: currSupplier?.address?.country?.name || '',
        postalCode: currSupplier?.address?.postalCode || '',
        vatNumber: currSupplier?.vatNumber || '',
        phones: currSupplier?.phones || []
    };
};
